var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcBulkUpdate({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.66668 12.3334C1.9303 12.3334 1.33333 11.7365 1.33333 11.0001L1.33333 6.25003C1.33333 5.88184 1.03486 5.58336 0.666666 5.58336C0.298476 5.58336 -7.60051e-07 5.88184 -6.4839e-07 6.25003L4.82128e-07 11.0001C8.09564e-07 12.4729 1.19393 13.6668 2.6667 13.6667L7.41668 13.6667C7.78487 13.6667 8.08334 13.3682 8.08333 13C8.08333 12.6318 7.78485 12.3334 7.41666 12.3334L2.66668 12.3334ZM2.5 9.00003C2.5 10.1966 3.47005 11.1667 4.66667 11.1667L9.16667 11.1667C10.3633 11.1667 11.3333 10.1966 11.3333 9.00003L11.3333 2.50002C11.3333 1.30341 10.3633 0.333358 9.16666 0.333358L4.66667 0.333359C3.47005 0.333359 2.5 1.30341 2.5 2.50003L2.5 9.00003ZM4.66667 9.83336C4.20643 9.83336 3.83333 9.46027 3.83333 9.00003L3.83333 2.50003C3.83333 2.03979 4.20643 1.66669 4.66667 1.66669L9.16666 1.66669C9.6269 1.66669 10 2.03979 10 2.50002L10 9.00003C10 9.46026 9.6269 9.83336 9.16667 9.83336L4.66667 9.83336Z",
    fill: "#116584"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBulkUpdate);
export default __webpack_public_path__ + "static/media/ic-bulk-update.b1ba27a628f8a361a5aa80fd5ef31b89.svg";
export { ForwardRef as ReactComponent };